<template>
  <div class="content-div">
    <div class="form-box">
      <el-form :rules="rules" ref="ruleForm" :model="drawerForm" label-width="130px">
        <div class="top-title">基础信息</div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="终端编号 : " prop="imei">
              <el-input v-model="drawerForm.imei" placeholder="请输入" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="ICCID卡号 : " prop="iccid">
              <el-input v-model="drawerForm.iccid" placeholder="请输入" size="small"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <el-row>-->
<!--          <el-col :span="12">-->
<!--            <el-form-item label="ICCID卡运营商 : " prop="simSupplier">-->
<!--              <el-select v-model="drawerForm.simSupplier" size="small" placeholder="请选择">-->
<!--                <el-option-->
<!--                    v-for="item in options"-->
<!--                    :key="item.value"-->
<!--                    :label="item.label"-->
<!--                    :value="item.value">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </el-form>
    </div>
    <div class="bottom-btn">
      <el-button @click="submitData(1)" :loading="submitType" type="primary" size="mini">确定</el-button>
      <el-button @click="submitData(2)" size="mini">取消</el-button>
    </div>
  </div>
</template>

<script>
import {addDataTbox, updateDataTbox} from "../../../common/terminalApi";

export default {
  name: "terminalAdministrationDialog",
  props: {
    drawerForm: {
      type: Object,
    },
    dialogType: {
      type: Number
    }
  },
  data(){
    return{
      rules: {
        imei: [
          { required: true, message: '请输入终端编号', trigger: 'blur' },
        ],
        iccid: [
          { required: true, message: '请输入ICCID卡号', trigger: 'blur' },
        ],
        simSupplier: [
          { required: true, message: '请选择ICCID卡运营商', trigger: 'change' }
        ],
      },
      submitType: false,
      options: [
        {
          label: '移动',
          value: 0,
        },
        {
          label: '联通',
          value: 1,
        },
        {
          label: '电信',
          value: 2,
        }
      ]
    }
  },
  methods: {
    // 数据提交
    async submitData(type) {
      /*
        * dialogType
        * 1   新增
        * 2   修改
        * */
      if (type === 1) {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            this.submitType = true
            if (this.dialogType === 1) {
              try {
                const res = await addDataTbox(this.drawerForm)
                if (res.code === 200) {
                  this.$notify.success({
                    title: '成功提示',
                    message: '终端新增成功'
                  })
                  this.submitType = false
                  this.$emit('drawerClose')
                } else {
                  this.$notify.error({
                    title: '错误提示',
                    message: res.msg
                  })
                  this.submitType = false
                }
              } catch (e) {
                this.submitType = false
                console.log(e)
              }
            } else {
              try {
                const res = await updateDataTbox(this.drawerForm)
                if (res.code === 200) {
                  this.$notify.success({
                    title: '成功提示',
                    message: '终端修改成功'
                  })
                  this.submitType = false
                  this.$emit('drawerClose')
                } else {
                  this.$notify.error({
                    title: '错误提示',
                    message: res.msg
                  })
                  this.submitType = false
                }
              } catch (e) {
                this.submitType = false
                console.log(e)
              }
            }
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      } else {
        this.$emit('drawerClose')
      }
    },
  }
}
</script>

<style scoped>
.content-div /deep/ .el-form-item__error {
  padding-top: 0 !important;
}
.form-box {
  box-sizing: border-box;
  padding: 0 60px 0 20px;
}

.form-box /deep/ .el-form-item {
  margin-bottom: 10px !important;
}

.top-title {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 18px;
  font-weight: 700;
}

.bottom-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
</style>
